/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/browser';
import { toCamelCase } from 'utils/caseConverter';
import { SocketChannels, SocketListener } from 'utils/socket';
import { buildApiErrorExtra } from './sentryErrorReport';
const progressClientMiddleware = ({ queryFn = () => null, queryFnCallback, socketChannelParams = [], socketCallback, timeoutQueryCallback = 100 }) => {
    const socketListener = new SocketListener();
    socketListener.register({
        name: SocketChannels.backgroundJobProgress(socketChannelParams),
        callback: (data) => {
            if (!data || !socketCallback)
                return;
            socketCallback(data, socketListener);
        },
        callbackConnected: async () => {
            setTimeout(async () => {
                const result = await queryFn();
                queryFnCallback && queryFnCallback(result, socketListener);
            }, timeoutQueryCallback);
        }
    });
    return socketListener;
};
class NetworkError extends Error {
    constructor(name, message) {
        super(message);
        this.name = name;
        this.stack = new Error().stack;
    }
}
const handleSentry = ({ error, endpoint, method }) => {
    if (error.name == 'ERR_CANCELED')
        return;
    Sentry.withScope(function (scope) {
        const getUserData = localStorage.getItem('userData');
        if (getUserData) {
            const userData = JSON.parse(getUserData);
            scope.setUser({ email: userData.email });
            scope.setTag('organization', userData.organizationName);
        }
        scope.setTag('pathname', location.pathname);
        scope.setTag('endpoint', endpoint);
        scope.setTag('type', `${error?.code ? error?.code : ''} ${error.message}`);
        scope.setExtras(buildApiErrorExtra({ error, endpoint, method }));
        scope.setFingerprint([method, error?.code.toString(), error?.message]);
        Sentry.captureException(new NetworkError(error?.name || error.code.toString(), error?.message));
    });
};
// Self-describing 403 (Performance-API #9582): the denial gate attaches a
// structured `reason`. Normalize it by hand from the snake_case wire body —
// toCamelCase would mangle `i18n_key` into `i18NKey` on the digit boundary.
const buildDenialReason = (reason) => {
    if (!reason)
        return undefined;
    return {
        code: reason.code,
        layer: reason.layer,
        i18nKey: reason.i18n_key,
        escalation: reason.escalation,
        params: reason.params
    };
};
const buildErrorData = (e) => {
    const rawError = e?.response?.data?.error
        ? e?.response?.data?.error
        : e?.response?.data?.errors;
    let error = toCamelCase(rawError);
    error = {
        name: e.code || 'ERR',
        message: error?.message || 'Something Went Wrong',
        code: error?.code || e.code,
        response: e.response,
        retryAfter: error?.retryAfter,
        reason: buildDenialReason(rawError?.reason)
    };
    if (e?.code == 'ERR_NETWORK') {
        error.message = 'Network Error';
        error.response = {
            data: {
                response: e?.request?.response,
                responseText: e?.request?.responseText,
                responseType: e?.request?.responseType,
                responseUrl: e?.request?.responseUrl,
                responseXML: e?.request?.responseXML
            }
        };
    }
    return error;
};
export { progressClientMiddleware, handleSentry, buildErrorData };
